<template>
  <header class="setting_header">
    <a class="setting_header_link" :href="mgHref">
      <img
        class="setting_header_logo"
        src="../assets/img/logo.png"
        alt="MatchinGood"
      />
    </a>

    <a class="setting_header_link setting_header_text mt-1" target="_blank" :href="entryHref">
      <span class="icon icon_candidate_resource icon_middle icon-size"></span>
      <p class="mt-1 item-font-size">
        {{ commonLabel.ENTRY_SCREEN_LINK }}
      </p>
    </a>

    <a class="setting_header_link setting_header_text mt-1" target="_blank" :href="jobHref">
      <span class="icon icon_job_offer icon_middle icon-size"></span>
      <p class="mt-1 item-font-size">
        {{ commonLabel.JOB_SEARCH_SCREEN_LINK }}
      </p>
    </a>
  </header>
</template>

<script>
import {Encrypt} from "@/plugins/cryptojs";
import commonLabel from "../properties/common_screen/commonsetting-labels.json"

const ENTRY_TEXT = "entry";
const JOB_TEXT = "job";
export default {
  name: "Header",
  data() {
    return {
      mgHref: "#",
      entryHref: "#",
      jobHref: "#",
      commonLabel: commonLabel
    }
  },
  async created() {
    let protocol = window.location.protocol;
    let groupName = window.location.hostname.slice(0, window.location.hostname.indexOf(".", 0));
    this.mgHref = protocol + "//" + groupName + "." + process.env.MG_BASE_DOMAIN;
    this.entryHref = window.location.origin + "/?c=" + encodeURIComponent(Encrypt(groupName + ENTRY_TEXT));
    this.jobHref = window.location.origin + "/?c=" + encodeURIComponent(Encrypt(groupName + JOB_TEXT));
  },

};
</script>

<style scoped>
.setting_header_text {
  color: #ffffff;
  margin-left: 60px;
  text-decoration: none;
  display: flex;
  flex-wrap: nowrap;
  justify-content: center;
  flex-direction: column;
  align-items: center;
}
.item-font-size {
  font-size: 8px;
}
.icon-size {
  font-size: 18px;
}
</style>
